function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#7B7B7B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  transform: "translate(1 1)"
}, React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#DBDBDB",
  rx: 1.5
}), React.createElement("line", {
  x1: 7,
  x2: 7,
  y2: 14
}), React.createElement("line", {
  x1: 14,
  y1: 7,
  y2: 7
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/grid.50a54a9b.svg";
export { SvgComponent as ReactComponent };